import Panel from './panel.vue'

export const Panels = {
  Panel,
  RowList: () => import('./list.vue'),
  Attachments: () => import('./attachments.vue'),
  Chips: () => import('./chips.vue'),
}
export default Panels
